import { useQuery } from '@tanstack/react-query';
import { userNotificationApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const POLL_INTERVAL = 60_000;

/** @registry The signed-in user's notifications, either all or unread only; kept fresh for the header bell count. */
export function useUserNotifications(filter: { unread: boolean }) {
  return useQuery({
    queryKey: queryKeys.userNotifications.list(filter),
    queryFn: ({ signal }) =>
      userNotificationApiClient.list(filter, toCancelToken(signal)),
    refetchOnWindowFocus: true,
    refetchInterval: POLL_INTERVAL,
    meta: { errorContext: 'notifications' },
  });
}
